document.addEventListener('DOMContentLoaded', function() {
    const categoryWrapper = document.querySelector('.category-wrapper');
    const categoryGrid = document.querySelector('.category-grid');
    
    // Only run on desktop where the grid is visible
    if (!categoryGrid || !categoryWrapper) return;

    const slider = categoryGrid;
    const categoryItems = categoryGrid.querySelectorAll('.category-item');
    let activeItem = categoryGrid.querySelector('.category-item.active');
    let currentHoveredItem = null;
    let returnTimer = null;

    // Function to update slider position
    function updateSliderPosition(targetItem) {
        if (!targetItem) return;
        
        const gridRect = categoryGrid.getBoundingClientRect();
        const itemRect = targetItem.getBoundingClientRect();
        const itemLink = targetItem.querySelector('a');
        const linkRect = itemLink.getBoundingClientRect();
        
        // Calculate position relative to the grid (accounting for scroll)
        const scrollLeft = categoryWrapper.scrollLeft;
        const left = linkRect.left - gridRect.left + scrollLeft;
        const width = linkRect.width;
        
        // Update CSS custom properties
        categoryGrid.style.setProperty('--slider-transform', `translateX(${left}px)`);
        categoryGrid.style.setProperty('--slider-width', `${width}px`);
    }

    // Function to scroll item into view if needed
    function scrollItemIntoView(item) {
        const wrapperRect = categoryWrapper.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        
        // Check if item is fully visible
        const isFullyVisible = itemRect.left >= wrapperRect.left && 
                              itemRect.right <= wrapperRect.right;
        
        if (!isFullyVisible) {
            // Calculate scroll position to center the item
            const itemCenter = itemRect.left + itemRect.width / 2;
            const wrapperCenter = wrapperRect.left + wrapperRect.width / 2;
            const scrollOffset = itemCenter - wrapperCenter;
            
            categoryWrapper.scrollBy({
                left: scrollOffset,
                behavior: 'smooth'
            });
        }
    }

    // Set initial position on active item
    if (activeItem) {
        updateSliderPosition(activeItem);
        // Scroll to active item on load
        setTimeout(() => scrollItemIntoView(activeItem), 100);
    }

    // Add hover event listeners
    categoryItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
            // Clear any existing return timer
            if (returnTimer) {
                clearTimeout(returnTimer);
                returnTimer = null;
            }
            
            currentHoveredItem = item;
            updateSliderPosition(item);
        });

        item.addEventListener('mouseleave', function() {
            currentHoveredItem = null;
            
            // Clear any existing timer
            if (returnTimer) {
                clearTimeout(returnTimer);
            }
            
            // Set a 2-second timer to return to active item
            returnTimer = setTimeout(function() {
                if (!currentHoveredItem && activeItem) {
                    updateSliderPosition(activeItem);
                }
                returnTimer = null;
            }, 500);
        });
    });

    // Update slider position on scroll
    categoryWrapper.addEventListener('scroll', function() {
        const targetItem = currentHoveredItem || activeItem;
        if (targetItem) {
            updateSliderPosition(targetItem);
        }
    });

    // Clear timer when hovering over the grid container
    categoryGrid.addEventListener('mouseenter', function() {
        if (returnTimer && currentHoveredItem) {
            clearTimeout(returnTimer);
            returnTimer = null;
        }
    });

    // Update on window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            const targetItem = currentHoveredItem || activeItem;
            if (targetItem) {
                updateSliderPosition(targetItem);
            }
        }, 100);
    });

    // Optional: Update active item on page navigation (if using AJAX)
    document.addEventListener('categoryChanged', function(e) {
        // Clear return timer if active
        if (returnTimer) {
            clearTimeout(returnTimer);
            returnTimer = null;
        }
        
        // Remove active class from previous item
        if (activeItem) {
            activeItem.classList.remove('active');
        }
        
        // Find new active item
        categoryItems.forEach(item => {
            const link = item.querySelector('a');
            if (link && link.href === window.location.href) {
                item.classList.add('active');
                activeItem = item;
            }
        });
        
        // Update slider position and scroll to new active item
        if (activeItem && !currentHoveredItem) {
            updateSliderPosition(activeItem);
            scrollItemIntoView(activeItem);
        }
    });
});

